
import Section1 from "@/views/users/views/list/navigation/list.nav";

const navigation = [
    {
        header: 'users'
    },
    Section1,
];

export default navigation;